import React from 'react'
import { AssetClassSource, QuoteAssetPair, YAxis } from 'types'

import useCatalog, { Catalog } from 'hooks/useCatalog'
import AssetClass from 'types/assetClass'

import useDefaultSeries from 'hooks/useDefaultSeries'
import ChartWrapper from '../common/BsLangChartWrapper'

const PerpetualSwapsMidPrice: React.FC = () => {
  const title = 'Perpetual swap price'
  const id = `${AssetClass.PERP}-${title}`

  const sources = AssetClassSource[AssetClass.PERP]
  const { data: catalog, isLoading: catalogLoading } = useCatalog({
    assets: [AssetClass.PERP],
    active: [true],
    sources,
    generateCurrencyPairs: true,
  })

  const deribitBTC = catalog?.deribit?.PERPETUAL?.BTC?.active.find(
    (c) => c.quoteAsset === QuoteAssetPair.USD,
  )
  const deribitETH = catalog?.deribit?.PERPETUAL?.ETH?.active.find(
    (c) => c.quoteAsset === QuoteAssetPair.USD,
  )

  const defaults = useDefaultSeries({
    catalogLoading,
    items: [deribitBTC, deribitETH],
    overRides: [undefined, { axis: { yAxis: YAxis.RIGHT } }],
    assetClass: AssetClass.PERP,
    path: 'px',
  })

  if (!catalogLoading && !catalog) {
    return <div>An Error occurred, please refresh.</div>
  }

  return (
    <ChartWrapper
      catalog={catalog as Catalog}
      defaultSeries={defaults}
      id={id}
      title={title}
      axisDefault={{ [YAxis.LEFT]: 'c0', [YAxis.RIGHT]: 'c0' }}
      assetClass={AssetClass.PERP}
      suffix="px"
    />
  )
}

export default PerpetualSwapsMidPrice
